import React from "react";
import "./Button.scss";

export default function Button({ text, href, newTab, download }) {
  const handleClick = () => {
    if (href) {
      if (download) {
        const link = document.createElement("a");
        link.href = href;
        link.download = download;
        document.body.appendChild(link);
        link.click();
        link.remove();
      } else {
        window.open(href, newTab ? "_blank" : "_self");
      }
    }
  };

  return (
    <div className="main-button" onClick={handleClick} style={{ cursor: "pointer" }}>
      {text}
    </div>
  );
}